import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    hotelExtra: [],
    lastError: null
};

export const hotelExtraSlice = createSlice({
    name: "hotelExtra",
    initialState: initialState,
    reducers: {

        catchError: (state, action) => {
            state.error = { ...action.payload.error };
            state.loading = false;
        },

        startCall: (state, action) => {
            state.error = null;
            state.loading = true;
        },

        hotelExtraFetched: (state, action) => {
            state.loading = false;
            state.error = null;
            state.hotelExtra = action.payload.hotelExtra;
        },
    }
});
